import { mapObjIndexed, invertObj } from 'ramda';
import { parameterize } from '../lib/strings';

export const CATEGORIES = {
  // the keys have to match the definitions in mojo, see app/enums/product_category.rb
  1: 'Accessories',
  2: 'Bags',
  3: 'Beauty',
  4: 'Clothing',
  5: 'Jewelry',
  6: 'Shoes',
  7: 'Vintage',
  8: 'Fine',
  10: 'Table Top',
  11: 'Linens',
  12: 'Decor',
  13: 'Technology',
  14: 'Dining And Entertaining',
  15: 'Fashion',
  16: 'Home Decor',
  17: 'Home Office',
  18: 'Bedding',
  19: 'Bath',
  20: 'Games And Technology',
  21: 'Home Fragnance',
  22: 'Furniture',
  23: 'Skincare',
  24: 'Hair',
  25: 'Makeup',
  26: 'Body',
  27: 'Fragrance',
  28: 'Health And Wellness',
  29: 'Experiences',
  30: 'Books',
  31: 'Sets',
  32: 'Special Products',
  33: 'Luggage And Travel Accessories',
  34: 'Stationery',
  35: 'Onesie',

  // TODO: get rid of these - these don't match keys from mojo, these are a workaround to 'fix' a problem with filtering, see ECOM-905
  101: 'Fine Jewelry',
  102: 'Fine_Jewelry',
  103: 'Fashion Jewelry',
  104: 'Fashion_Jewelry',
  105: 'Table Linens',
  106: 'Gifts',
  107: 'Children',
  108: 'Pets'
};

export const CATEGORY_SLUGS = mapObjIndexed(category => parameterize(category), CATEGORIES);

export const CATEGORIES_BY_SLUG = invertObj(CATEGORY_SLUGS);

export type CategoryKey = keyof typeof CATEGORIES;

export type Category = (typeof CATEGORIES)[CategoryKey];
